import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, Events } from 'ionic-angular';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { SoundsProvider } from '../../providers/sounds/sounds';

/**
 * Generated class for the CoFailedItemCheckoutModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-failed-item-checkout-modal',
  templateUrl: 'co-failed-item-checkout-modal.html',
})
export class CoFailedItemCheckoutModalPage {
  book: any;
  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl : ViewController, private events : Events, private timeout : TimeoutFunctionsProvider, private sounds : SoundsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.navParams.data.book.bib? this.book = this.navParams.data.book.bib : this.book = this.navParams.data.book;
  }

  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }

  ngOnInit(): void {
    // console.log(this.book);
  }

  close(){
    this.viewCtrl.dismiss().catch(err=>{});
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-failed-item-checkout-modal/co-failed-item-checkout-modal.ts